import { useContext } from 'react';
import { LessonContext } from '../context/lesson-context';

const useLessonContext = () => {
  const context = useContext(LessonContext);
  if (!context) {
    throw new Error('useLessonContext must be used within a LessonContext');
  }
  return context;
};
export default useLessonContext;
